// src/components/DoubleBox2.js
import React from 'react';
import './DoubleBox.css'; 
import { FaCalendarAlt } from 'react-icons/fa'; 

const DoubleBox2 = () => {
  return (
    <div className="half-width-box">
      <div className="box-content">
        
        {/* Text Section */}
        <div className="text-section">
          <h2 className="box-title">When will the event take place?</h2>
          <p>The event will be held on November 19-20-21, 2026.</p>
        </div>

        {/* Icon Section */}
        <div className="icon-section right-icon">
          <div className="icon-background">
            <FaCalendarAlt className="calendar-icon" />
          </div>
        </div>

      </div>
    </div>
  );
};

export default DoubleBox2;